<div [@routerTransition]>
    <sub-header [title]="('AddProduction' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="Production_PDate">{{ l('PDate') }}</label>

                            <abp-datetime-picker #Production_productionDate="ngModel" [(ngModel)]="production.productionDate"
                                                 id="AddStock_date" name="Production_productionDate"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="Production_productionDate"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="production_Remarks">{{ l('Remarks') }}</label>
                            <input type="text"
                                   id="production_Remarks" class="form-control"
                                   [(ngModel)]="production.remarks" name="Remarks" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="10%">{{ l('ItemCode') }}</th>
                                    <th width="30%">{{ l('ItemName') }}</th>
                                    <th width="8%">{{ l('QtyOnHand') }}</th>
                                    <th width="8%">{{ l('Qty') }}</th>
                                    <th width="8%">{{ l('UOM') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of productproductionDetails; let i = index">
                                    <td class="text-center">
                                        <div class="d-flex align-items-center">
                                            <button class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px" (click)="removeItem(i)">
                                                x
                                            </button>
                                            <span class="ps-1"><b>{{ data.slNo }}</b></span>
                                        </div>
                                        <!-- (click)="removeItem(i)" -->
                                    </td>
                                    <td>
                                        <input type="text" #itemCodeInput class="form-control" [(ngModel)]="data.productCode"
                                               (keydown.enter)="getProductionProduct($event,data.productCode,data,i)"
                                               (blur)="getProductionProduct($event,data.productCode,data,i)" />
                                    </td>
                                    <td>
                                        <select name="data.productId"
                                                [(ngModel)]="data.productId"
                                                class="form-select"
                                                (change)="getProductionProduct($event,null,data,i)"
                                                required>

                                            <option *ngFor="let item of productionProducts" value="{{ item.id }}">
                                                {{ item.displayName }}
                                            </option>
                                        </select>
                                        <!--<app-search-product (productEvent)="getProduct($event,data,i)" [productSelectedItem]="data.productSelectedItem"> </app-search-product>-->
                                    </td>
                                    <td class="text-end  align-middle"><b>{{data.qtyOnHand}}</b></td>
                                    <td>
                                        <input type="text" #qtyInput
                                               class="form-control text-end" appAllowDecimal [(ngModel)]="data.qty"
                                               (ngModelChange)="getRawMaterialItems()" />
                                    </td>
                                    <td class="text-end align-middle">
                                        <a><span><b> {{data.unitName}} </b> </span> </a>

                                    </td>

                                    <td width="5%" class="text-center">
                                        <button #addButton class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                style="width: 30px; height: 30px" (click)="addRow(i)">
                                            +
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-end"><label class="control-label"><b>{{ l('TotalQty') }}</b></label></td>
                                    <td class="text-end"><b>{{production.productionQty}}</b></td>
                                    <td class="text-right"></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row mt-3" *ngIf="productRawMaterials.length > 0">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="10%">{{ l('ItemCode') }}</th>
                                    <th width="30%">{{ l('ItemName') }}</th>
                                    <th width="8%">{{ l('QtyOnHand') }}</th>
                                    <th width="8%">{{ l('ProductionQty') }}</th>
                                    <th width="8%">{{ l('Qty') }}</th>
                                    <th width="8%">{{ l('VarianceQty') }}</th>
                                    <th width="8%">{{ l('UOM') }}</th>

                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of productRawMaterials; let i = index">

                                    <td>
                                        {{data.productCode}}
                                    </td>
                                    <td>
                                        {{data.productName}}
                                    </td>
                                    <td class="text-end  align-middle"><b>{{data.qtyOnHand}}</b></td>
                                    <td>
                                        <input type="text"  class="form-control text-end" disabled="disabled" [(ngModel)]="data.qty" />
                                    </td>
                                    <td>
                                        <input type="text" #qtyInput 
                                               class="form-control text-end" appAllowDecimal [(ngModel)]="data.availableQty"
                                               (ngModelChange)="calculateTotalValues()" />
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-end" disabled="disabled" [(ngModel)]="data.varianceQty" />
                                    </td>
                                    <td class="text-end align-middle">
                                        <a><span><b> {{data.unitName}} </b> </span> </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td class="text-end"><b>{{ l('TotalQty') }}</b></td>
                                    <td class="text-end"><b>{{totalQty | number: '1.2-3'}}</b></td>
                                    <td class="text-end"><b>{{production.productionInputQty | number: '1.2-3'}}</b></td>
                                    <td class="text-end"><b>{{production.productionVarianceQty | number: '1.2-3'}}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(status.Draft)" class="btn btn-primary blue me-2" [buttonBusy]="saving"
                            *ngIf="production.status == status.Draft"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAsDraft') }}</span>
                    </button>

                    <button (click)="save(status.Added)" *ngIf="production.id == null"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }} {{production.id}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
